module.exports = {"insuranceinquiry":{"tabs":{"overview":["Overview","Overblik"],"application":["Application","Overblik"],"calculator":["Calculator","Regnemaskine"]}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/main/insurance_inquiry.locale.json
// module id = 686
// module chunks = 0